import './oiInterests.css';
import React, { Component } from 'react';

import axios from 'axios';
import History from '../../History';
import FaClose from 'react-icons/lib/fa/close';

import OiMenu from '../oiMenu/oiMenu';
import OiModal from '../oiModal/oiModal';
import OiButton from '../oiButton/oiButton';
import OiLoading from '../oiLoading/oiLoading';
import OiHeaderLite from '../oiHeaderLite/oiHeaderLite';

class OiInterests extends Component {
    state = {
        categories: '',
        isLoading: true,
        menuIsOpen: false,
        modalIsOpen: false,
        btnIsDisabled: true,
        selectedCategories: [],
        msisdn: sessionStorage.getItem('msisdn'),
        userData: sessionStorage.getItem('userData'),
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentDidMount = () => {
        if (!sessionStorage.getItem("msisdn") || !sessionStorage.getItem("sessionToken") || !sessionStorage.getItem("userData")) {
            History.push(`${process.env.PUBLIC_URL}/`);
        }

        this.buildCategories();
        setTimeout(() => { this.refreshToken() }, (10 * 60 * 1000));
    }

    manageModalWithCallback = (callback) => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });

        callback();
    }

    menuToogleHandler = () => {
        this.setState({ menuIsOpen: !this.state.menuIsOpen });
    }

    radioButtonHandler = (event) => {
        let category = [];
        let hasCategory = this.state.selectedCategories.find((item) => event.target.value === item);

        if (event.target.checked && !hasCategory) {
            category = [
                ...this.state.selectedCategories,
                event.target.value
            ];

            this.setState({ selectedCategories: category });
        }
        else {
            let newArray = this.state.selectedCategories;
            let index = this.state.selectedCategories.indexOf(event.target.value);
            if (index > -2) {
                newArray.splice(index, 1);
            }

            this.setState({ selectedCategories: newArray });
        }

        if (this.state.selectedCategories.length <= 0 && category.length <= 0) {
            this.setState({ btnIsDisabled: true });
        }
        else {
            this.setState({ btnIsDisabled: false });
        }
    }

    btnClickHandler = () => {
        //API UPDATE PROFILE
        let self = this;
        let selectedCategories = this.state.selectedCategories;
        let params = JSON.stringify({ data: { interests: selectedCategories } });
        this.setState({ isLoading: true, btnIsDisabled: true });

        let url = 'https://api.oston.io/clicnoticia/v1/profile';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.put(url, params, config)
            .then(userData => {
                sessionStorage.setItem('userData', JSON.stringify(userData.data.user));
                History.push(`${process.env.PUBLIC_URL}/noticias`);
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao atualizar suas categorias. Por favor, recarregue a página e tente novamente.',
                        btn1: 'Recarregar',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/interesses`);
                                window.location.reload();
                            })
                        }
                    }
                });
            });
    }

    buildCategories = () => {
        //API GET CATEGORIES
        let self = this;
        let url = sessionStorage.getItem('isBundle') === "yes" ?
            'https://api.oston.io/clicnews-lite/v1/news/categories'
            :
            'https://api.oston.io/clicnoticia/v2/news/categories';
        const config = {
            headers: {
                'Accept': 'application/json'
            }
        };

        axios.get(url, config)
            .then(response => {
                let array = [];
                let arrayAux = [];
                let hasCategory = false;
                let categories = response.data.data;

                if (JSON.parse(self.state.userData).data === null) {
                    array.push(categories.map((category, index) => {

                        arrayAux = [
                            ...self.state.selectedCategories,
                        ];

                        this.setState({ selectedCategories: arrayAux, btnIsDisabled: true });

                        return (
                            <div key={category.id} className="radio-button-box">
                                <label>
                                    <span>{category.name}</span>
                                    <input
                                        type="checkbox"
                                        value={category.slug}
                                        className="radio-button"
                                        defaultChecked={false}
                                        onClick={(event) => { self.radioButtonHandler(event) }}
                                    />
                                </label>
                            </div>
                        );
                    }));
                }
                else {
                    array.push(categories.map((category, index) => {
                        let newArray = JSON.parse(self.state.userData).data.interests;
                        hasCategory = newArray.find((item) => category.slug === item);

                        if (hasCategory) {
                            arrayAux = [
                                ...self.state.selectedCategories
                            ];

                            arrayAux.push(category.slug);
                        }
                        else {
                            arrayAux = [
                                ...self.state.selectedCategories,
                            ];
                        }

                        this.setState({ selectedCategories: arrayAux, btnIsDisabled: true });

                        return (
                            <div key={category.id} className="radio-button-box">
                                <label>
                                    <span>{category.name}</span>
                                    <input
                                        type="checkbox"
                                        value={category.slug}
                                        className="radio-button"
                                        defaultChecked={hasCategory}
                                        onClick={(event) => { self.radioButtonHandler(event) }}
                                    />
                                </label>
                            </div>
                        );
                    }));
                }

                this.setState({
                    isLoading: false,
                    categories: array,
                });
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao atualizar suas categorias. Por favor, recarregue a página e tente novamente.',
                        btn1: 'Recarregar',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/interesses`);
                                window.location.reload();
                            })
                        }
                    }
                });
            });
    }

    refreshToken = () => {
        //API REFRESH TOKEN
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/auth/token/refresh';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.post(url, {}, config)
            .then(refresh => {
                sessionStorage.setItem('sessionToken', refresh.data.token);
                setTimeout(() => { self.refreshToken() }, (10 * 60 * 1000));
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Sua sessão expirou. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    render = () => {
        let Menu = '';

        if (sessionStorage.getItem('isBundle') === 'yes') {
            if (this.state.menuIsOpen) {
                Menu = (
                    <OiMenu
                        widthMenu={'75%'}
                        widthLayer={'100%'}
                        widthContainer={'100vw'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }
            else {
                Menu = (
                    <OiMenu
                        widthMenu={'0'}
                        widthLayer={'0'}
                        widthContainer={'0'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }
        }

        return (
            <div id="oi-interests">
                {this.state.isLoading ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}
                {sessionStorage.getItem('isBundle') === 'yes' ? Menu : ''}

                {
                    sessionStorage.getItem('isBundle') === 'yes' ?
                        <OiHeaderLite
                            isBundle={true}
                            clickEvent={() => { this.menuToogleHandler() }}
                        />
                        :
                        <FaClose
                            id="oi-interests-close-icon"
                            onClick={() => { History.push(`${process.env.PUBLIC_URL}/`); }}
                        />
                }

                <div id="oi-interests-box"
                    className={sessionStorage.getItem('isBundle') === 'yes' ? '' : 'interests-height-full'}>
                    <span id="oi-interests-box-span">SEUS INTERESSES</span>
                    <h1>Selecione um ou mais interesses</h1>
                    <div id="oi-interests-box-select">
                        {this.state.categories}
                    </div>
                </div>

                <OiButton
                    value="Definir Interesses" isDisabled={this.state.btnIsDisabled}
                    clickEvent={() => { this.btnClickHandler() }}
                />
            </div>
        );
    }
};

export default OiInterests;


// WEBPACK FOOTER //
// ./src/components/oiInterests/oiInterests.js